import React from 'react';
import { Icon, List } from 'semantic-ui-react';
import { PASSWORD_RULES } from '../utils/password-policy';

interface PasswordRequirementsHintProps {
    password?: string;
    compact?: boolean;
}

const PasswordRequirementsHint: React.FC<PasswordRequirementsHintProps> = ({
    password = '',
    compact = false,
}) => (
    <div style={{ marginTop: compact ? '0.25rem' : '0.5rem', marginBottom: '0.75rem' }}>
        {!compact && (
            <strong style={{ fontSize: '0.9em', color: '#555' }}>A senha deve conter:</strong>
        )}
        <List bulleted={!compact} size="small" style={{ marginTop: '0.35rem', color: '#666' }}>
            {PASSWORD_RULES.map((rule) => {
                const ok = password.length > 0 && rule.test(password);
                const pending = password.length === 0;
                return (
                    <List.Item key={rule.id} style={{ color: pending ? '#888' : ok ? '#21ba45' : '#db2828' }}>
                        {!pending && (
                            <Icon
                                name={ok ? 'check circle' : 'times circle'}
                                style={{ marginRight: '0.25rem' }}
                            />
                        )}
                        {rule.label}
                    </List.Item>
                );
            })}
        </List>
    </div>
);

export default PasswordRequirementsHint;
